export default "__VITE_ASSET__c2ldBaIT__"